export default {
    "title": "Check your points and rewards with your phone.",
    "phoneLabel": "Enter your phone number",
    "phonePlaceholder": "(99) 9 9999-9999",
    "enterButton": "Enter",
    "step2Message1": "We are sending a code to your mobile phone via SMS, it can take up to 3 minutes to arrive.",
    "step2Message2": "We sent another SMS to you, if you don't receive it please report the incident to our establishment.",
    "authCode": "Authentication Code",
    "resendButton": "Send again",
    "resendWait": "Resend in {seconds}s",
    "codeLabel": "Confirmation code",
    "codePlaceholder": "Enter the code here",
    "verifyButton": "Verify",
    "backButton": "Back",
    "signupTitle": "We couldn't find your mobile number, please fill out the form to sign up.",
    "firstNameLabel": "First Name",
    "firstNamePlaceholder": "Enter your first name",
    "lastNameLabel": "Last Name",
    "lastNamePlaceholder": "Enter your last name",
    "birthdateLabel": "Date of Birth",
    "birthdatePlaceholder": "MM/DD/YYYY",
    "emailLabel": "Your email",
    "emailPlaceholder": "email@email.com",
    "signUpButton": "Sign up",
    "errorUnknown": "Something went wrong, please try again later.",
    "errorPhoneNotFound": "It looks like you have never ordered here — we are waiting for you!",
    "errorInvalidCode": "That code is not valid, please try again."
};
